import { Flex } from '@talos/kyoko';
import styled from 'styled-components';
import { Wrapper } from '../../../../components/Ladder/PriceIncrement/styles';

export const PriceIncrementWrapper = styled(Flex)`
  position: absolute;
  align-items: center;
  right: ${({ theme }) => theme.spacing12}px;
  top: ${({ theme }) => theme.spacing8}px;
  z-index: 2;

  ${Wrapper} {
    background: ${({ theme }) => theme.colors.gray['040']};
    border-radius: ${({ theme }) => theme.borderRadiusDefault}px;
    font-size: 12px;
    height: 24px;
    line-height: 1;
    padding: 0 ${({ theme }) => theme.spacing4}px;
  }
`;
